// Centralized site information
export const SITE = {
  brand: "DJ AS Animation",
  djName: "Adrien Sebert",
  phone: "0642645614",
  phoneInternational: "+33642645614",
  phoneDisplay: "06 42 64 56 14",
  email: "asanimation61@gmail.com",
  website: "www.asanimation61.com",
  whatsappBase: "https://wa.me/33642645614",
  whatsappDefaultMsg:
    "Bonjour Adrien, je souhaiterais avoir des informations pour réserver un DJ pour mon événement.",
  reviewsUrl:
    "https://www.google.com/maps/place/Adrien+Sebert/data=!4m2!3m1!1s0x47e2054e88aa6991:0xa334f0bd8cc99a44?hl=fr",
  googleBusinessUrl: "https://share.google/HznwWYdID2xxv2g5v",
  socials: {
    tiktok: "https://www.tiktok.com/@coulisse.dj",
    instagram: "https://www.instagram.com/dj_as_adriensebert/",
    facebook: "https://www.facebook.com/adriensebert",
    youtube: "https://www.youtube.com/@Adriensebert",
    linkedin: "https://www.linkedin.com/in/adrien-sebert-848373157/",
    soundcloud: "https://soundcloud.com/user-408608435",
  },
  city: "La Chapelle-près-Sées (61500)",
  areas: ["Normandie", "Orne", "Sarthe", "Mayenne", "Calvados", "Eure", "Île-de-France"],
};

export const waLink = (msg) =>
  `${SITE.whatsappBase}?text=${encodeURIComponent(msg || SITE.whatsappDefaultMsg)}`;
